import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { BROADCAST_ROLES } from '../services/stateBroadcastService';

// Roles that belong to the Content Manager / news-broadcast side of the app.
export const CM_ROLES = [
  'admin',
  'content creator',
  'global',
  'master',
  'superadmin',
  // The seeded role's real name is "super admin" (with a space) —
  // "superadmin" above never matched it, so a Super Admin account typing
  // /news-livestream directly (or any CM_ROLES-guarded route) got bounced
  // to redirectTo even though the login redirect itself (once fixed the
  // same way) would happily have sent them there.
  'super admin',
  'cm',
  ...BROADCAST_ROLES,
];

const currentRole = () =>
  (localStorage.getItem('isAdminValue') || '').trim().toLowerCase();

// Wraps a route element and only renders it when the logged-in user's role
// (localStorage "isAdminValue") is in `allow`. Anyone else is bounced to
// `redirectTo` instead of seeing the page — this was previously nothing more
// than "the login redirect happens to send you elsewhere," which never
// stopped someone from just typing the URL in directly.
const RoleGuard = ({ allow, redirectTo = '/home', children }) => {
  const location = useLocation();
  const role = currentRole();
  const allowed = allow.map((r) => r.toLowerCase()).includes(role);

  // A VRS guest has no account at all — they join by Virtual Code, optionally
  // after paying, so `isAdminValue` is empty and the role check above can
  // never pass. Without this they were bounced to /home right after a
  // successful (sometimes paid) join, which looked like "nothing happens".
  //
  // The pass is not just "no role": it requires the state that only a real
  // join produces — guestSessionId comes back from the backend's
  // claim-guest-slot call, and the invite-link/reporter paths set their own
  // flags. Typing /news-livestream in the address bar carries no router
  // state, so that is still blocked exactly as before.
  const s = location.state || {};
  const hasGuestSession = Boolean(
    s.guestSessionId ||
      s.isInviteLinkGuest ||
      s.isReporterByJoinLive ||
      (s.JoinLive && s.JoinLiveRoom),
  );

  if (!allowed && !hasGuestSession) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
};

export default RoleGuard;
